import { fetchOptions } from './csrf'

export const CHANNEL_OPTIONS = [
  { value: 'ebay_national', label: 'eBay National' },
  { value: 'ebay_local', label: 'eBay Local' },
  { value: 'website', label: 'Website' },
  { value: 'sell_your_car', label: 'Sell Your Car' },
] as const

export interface SalesChannelAssignment {
  id: string
  user_id: string
  channel_name: string
  created_at: string
  updated_at: string
}

export interface UserWithChannels {
  user_id: string
  user_name: string
  user_email: string
  channels: string[]
}

interface IndexResponse {
  sales_channel_assignments: SalesChannelAssignment[]
  users: UserWithChannels[]
}

interface BulkUpdateResponse {
  sales_channel_assignments: SalesChannelAssignment[]
  users: UserWithChannels[]
}

interface ErrorResponse {
  errors: string[]
}

export const salesChannelAssignmentsApi = {
  async index(): Promise<IndexResponse> {
    const response = await fetch('/api/v1/settings/sales-channels', fetchOptions())
    if (!response.ok) throw new Error('Failed to load sales channel assignments')
    return response.json()
  },

  async bulkUpdate(assignments: { user_id: string; channel_names: string[] }[]): Promise<BulkUpdateResponse> {
    const response = await fetch('/api/v1/settings/sales-channels/bulk_update', {
      ...fetchOptions('PUT'),
      body: JSON.stringify({ assignments }),
    })
    if (!response.ok) {
      const data: ErrorResponse = await response.json().catch(() => ({ errors: ['Failed to update assignments'] }))
      throw new Error(data.errors.join(', '))
    }
    return response.json()
  },
}
